import type { ReactNode } from "react";

// Sektionshuvud: mono-eyebrow, rubrik och valfritt innehåll till höger (t.ex. en chip).
export function Shead({ eyebrow, rubrik, hoger }: { eyebrow: string; rubrik: ReactNode; hoger?: ReactNode }) {
  return (
    <div className="shead">
      <div className="t">
        <span className="eyebrow">{eyebrow}</span>
        <h2 className="h2">{rubrik}</h2>
      </div>
      {hoger}
    </div>
  );
}
